export default {
  maps: {
    confirm: "Confirm",
    updateConfirmation: "Are you sure you want to update the coordinates in the database?",
    deleteConfirmation: "Are you sure you want to delete this counter?",
    backToOldPosition: "Revert to old position",
    addCounter: "Add a counter",
    savePosition: "Save position",
    deleteCounter: "Delete counter",
    export: "Export",
  },
};
